export const ADMIN_SCHOOL_CARD_OPTION = {
  ACCESS_CODE: 'accessCode',
  USERS: 'users',
  PRODUCTS: 'products',
  CLASSES: 'classes',
  REPORTS: 'reports'
};
